<template>
  <div class="loginArea">
    <div v-if="!isLogin" class="signIn">
      <el-button class="loginBtn" @click="goLogin">
        登录
      </el-button>
      <el-button class="regBtn" @click="gouserRegistration">
        注册
      </el-button>
    </div>
    <div v-else class="loginOut">
      <el-dropdown trigger="click">
        <div class="user ">
          <template v-if="!isLogin&&(userImage==null||userImage=='')"><!-- !$store.state.userImage -->
            <svg class="iconfont el-dropdown-link" aria-hidden="true" >
              <use xlink:href="#icon-touxiangnanhai"></use>
            </svg>{{ user }}
          </template>
          <template v-else>
            <img class="userPhoto"  :src="userImage" />
            {{ user }}
          </template>
        </div>
        <el-dropdown-menu slot="dropdown" class="tips">
          <el-dropdown-item class="hoverBack">
            <router-link to="/memberCenterIndex" class="noLine">
              <i class="iconfont icon-huiyuan"></i>会员中心
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item class="hoverBack">
            <router-link to="/memberCenterIndex/personalInformation" class="noLine">
              <i class="iconfont icon-xiugaixinxi-gongsi"></i>修改信息
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item class="noLine hoverBack">
            <div @click="logOut">
              <i class="iconfont icon-tuichu1"></i>退出账号
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-badge :value="unReadMsg" class="messageCenter" @click.native="goMessageReminder()">
        <i class="iconfont icon-message"></i>
      </el-badge>
    </div>
  </div>
</template>

<script>
  export default ({
    name: "loginArea",
    data() {
      return {
        isLogin: this.$store.state.islogined ? true : false, //是否已登录 true表示登录
        user: this.$store.state.user,
        userImage: this.$store.state.defaultPicUrl+this.$store.state.userImage,//头像地址
        userId: this.$store.state.userId,
        unReadMsg: 0, //未读消息
        msgType: "MESSAGE_TYPE_ANNOUNCEMENT,MESSAGE_TYPE_FEEDBACK,MESSAGE_TYPE_ORDERNOTIFY,MESSAGE_TYPE_USERLOG,MESSAGE_TYPE_ACCOUNTSECURITY" //全部消息  小类
      }
    },
    computed: {
      getUserInfoChange() {
        return {'user':this.$store.state.user,'userImage':this.$store.state.userImage};
      }
    },
    watch: {
      //监听全局用户昵称变化，导航条显示昵称及时更新
      getUserInfoChange: {
        handler(newValue, oldValue) { //当词条改变时执行事件
          if(newValue.user){
            this.user = newValue.user;
          }
          if(newValue.userImage){
            this.userImage = this.$store.state.defaultPicUrl+newValue.userImage;
          }
        }
      }
    },
    created: function() {
      //2.初始化查询未读消息数量
      this.queryUnReadMsg();
    },
    methods: {
      gomemberCenter() {
        this.$router.push("/memberCenterIndex")
      },
      goLogin() {
        this.$router.push("/userLogin");
      },
      gouserRegistration() {
        this.$router.push("/userRegistration")
      },
      goInformation() {
        this.$router.push("/memberCenterIndex/personalInformation");
      },
      logOut() {
        if(!this.$store.state.userId)return;
        let this_ = this;
        let paramdata = {};
        paramdata.data = {
          "userId": this.$store.state.userId,//默认用户id
          "userName": this_.$store.state.user,
          "client": this_.$store.state.defaultClient,
          "clientSys": this_.$store.state.defaultClientSys,
          "systemcode":this_.$store.state.systemcode //系统编号
        };
        paramdata.url = '/jwt/token/logOut';
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            this_.$store.commit('LOGOUT', ''); //退出登录
            this_.user = this_.$store.state.user; //登录账号昵称
            this_.isLogin = this_.$store.state.islogined ? true : false; //是否已登录 true表示登录
            this_.$router.push("/"); //回到首页
          } else {
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      //跳转未读消息页面
      goMessageReminder() {
        this.$router.push({
          path: "/memberCenterIndex/messageReminder",
          query: {
            "msgType": this.msgType,
            "queryType": "QUERYLIST_UNREAD"
          }
        });
      },
      //查询未读消息数量
      queryUnReadMsg() {
        //未登录不获取未读消息
        if(!this.$store.state.userId)return;
        let this_ = this;
        let paramdata = {};
        paramdata.data = {
          "type": this.msgType,
          "receiveUserId": this.$store.state.userId
        };
        paramdata.url = '/SJHG/publicplat/member/msg/msgCountUnRead';

        paramdata.onSuccess = function(res) {
          // console.log('-------------查询未读消息数量-----------------');
          if (res.data.ok) {
            this_.unReadMsg = res.data.result;
          } else {
            // let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      }
    }
  })
</script>

<style scoped lang="scss">
  .iconfont {
    vertical-align: 0;
  }

  .loginArea {
    width: 320px;
    height: 40px;
    background: #252B3A;
  }

  .signIn {
    display: flex;
    width: 100%;
    height: 40px;
    justify-content: flex-end;
  }

  .loginOut {
    display: flex;
    height: 40px;
    justify-content: flex-end;
    width: 100%;
    padding-top: 7px;
    box-sizing: border-box;
  }

  .memberCenter,
  .user,
  .messageCenter {
    margin: 0px 6px;
    cursor: pointer;
  }

  >>>.el-button {
    border-radius: 0;
  }

  .loginIn {
    text-decoration: none;
    color: $color-primary;
  }

  .registrBtn {
    text-decoration: none;
    color: #fff;
  }

  .loginBtn {
    color: $color-primary;
    padding: 8px 15px;
    border: 1px solid #626060;
    background: #252B3A;
    height: 40px;
  }

  .loginBtn:hover {
    background: $color-primary;
    color: #fff;
    border: 1px solid $color-primary;
  }

  .loginBtn:hover .loginIn {
    color: #fff;
  }

  .regBtn {
    background: $color-primary;
    color: #ffffff;
    border: 1px solid #626060;
    padding: 8px 15px;
    height: 40px;
  }

  .regBtn:hover {
    background: $color-primary-light-1;
    color: #ffffff;
    border: 1px solid $color-primary-light-1;
  }

  .memberCenter {
    color: #fff;
  }

  .memberCenter i {
    border-radius: 50%;
    padding: 3px;
    color: #fff;
    margin-right: 5px;
    vertical-align: 0;
  }

  .messageCenter i {
    font-size: 24px;
    color: #fff;
  }

  .user {
    display: flex;
    color: #fff;
  }

  .user svg {
    font-size: 25px;
    margin-right: 5px;
  }

  .user:hover {
    color: #fff;
  }

  .user:hover,
  .messageCenter i:hover,
  .loginOut:hover,
  .memberCenter:hover,
  .noLine:hover {
    color: $color-primary;
  }

  .noLine {
    text-decoration: none;
    color: #fff;
  }

  .tips {
    background: rgb(77, 88, 115);
    color: #fff;
    border: 1px solid rgb(77, 88, 115);
    top: 50px !important;
  }

  >>>.popper__arrow::after {
    border-bottom-color: rgb(77, 88, 115) !important;
    color: #000000 !important;
  }

  .hoverBack:hover {
    background: rgb(77, 88, 115) !important;
  }

  >>>.el-dropdown {
    font-size: 16px;
  }
  .userPhoto{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/loginArea.vue